import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError, AxiosRequestConfig, AxiosResponse, Method } from 'axios';

import { publicApi } from '@/utils/api';

interface UsePublicApiMutationOptions<ResponseType, ErrorType, RequestDataType> extends Omit<
  UseMutationOptions<AxiosResponse<ResponseType>, AxiosError<ErrorType>, RequestDataType>,
  'mutationFn'
> {
  requestConfig?: Omit<AxiosRequestConfig, 'url' | 'method' | 'data'>;
}

const usePublicApiMutation = <ResponseType, ErrorType, RequestDataType>(
  url: string,
  method: Method,
  options?: UsePublicApiMutationOptions<ResponseType, ErrorType, RequestDataType>,
): UseMutationResult<AxiosResponse<ResponseType>, AxiosError<ErrorType>, RequestDataType> =>
  useMutation({
    mutationFn: (data) =>
      publicApi.request({
        url,
        method,
        data,
        ...options?.requestConfig,
      }),
    ...options,
  });

export default usePublicApiMutation;
